// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.logos.RentalManagerUserPropertyLogoWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { RentalManagerUserPropertyLogoWebApiHandler_upload } from '@zg-rentals/ts-rental-manager-api-client';

import type {
  ListingAlias,
  UserPropertyLogoUploadRequestWebDto,
  UserPropertyLogoUploadResponseWebDto,
} from '@zg-rentals/ts-rental-manager-api-client';

interface UploadParams {
  listingAlias: ListingAlias;
  sourceUrl?: string;
}

export interface RentalManagerUserPropertyLogoWebApiHandler_upload_Args {
  getParams: UploadParams;
  postData: UserPropertyLogoUploadRequestWebDto;
}

export type RentalManagerUserPropertyLogoWebApiHandler_upload_Options = UseMutationOptions<
  UserPropertyLogoUploadResponseWebDto,
  unknown,
  RentalManagerUserPropertyLogoWebApiHandler_upload_Args
>;

/**
 * Upload a property logo
 */
export const useRentalManagerUserPropertyLogoWebApiHandler_upload = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyLogoWebApiHandler_upload_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyLogoWebApiHandler_upload_Args) =>
      RentalManagerUserPropertyLogoWebApiHandler_upload(args.getParams, args.postData, httpClient),
  });
};
